import script from "./VideoPreviewModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPreviewModal.vue?vue&type=script&lang=ts&setup=true"

import "./VideoPreviewModal.vue?vue&type=style&index=0&id=a19fdf90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a19fdf90"]])

export default __exports__